export const PercentageFilter = ['$filter', ($filter: ng.IFilterService) => {
    return function (input, decimals) {
        return input ? $filter('number')(input, decimals) + '%' : 'Unknown';
    }
}];